import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import BlueprintIcon from '../../../../../../BlueprintIcon';
import ClockRegularIcon from '../../../../../../Icons/ClockRegularIcon';

type ConfirmationStepHeaderProps = {
    approvalRequired: boolean;
};

export const ConfirmationStepHeader: FunctionComponent<ConfirmationStepHeaderProps> = ({
    approvalRequired,
}) => {
    if (approvalRequired) {
        return (
            <section
                className={styles.confirmationStepHeader}
                aria-labelledby="confirmation-step-header"
            >
                <ClockRegularIcon className={styles.bookingConfirmedIcon} />
                <h1 id="confirmation-step-header" className={styles.checkoutStepHeader}>
                    Your Booking is Awaiting Approval
                </h1>
            </section>
        );
    }

    return (
        <section
            className={styles.confirmationStepHeader}
            aria-labelledby="confirmation-step-header"
        >
            <BlueprintIcon icon={'CheckMarkCircle'} className={styles.bookingConfirmedIcon} />
            <h1 id="confirmation-step-header" className={styles.checkoutStepHeader}>
                Booking Confirmed
            </h1>
        </section>
    );
};
